import { atom } from 'recoil';
import { CurrentUser } from '../../domain/User';

export const currentUserState = atom<CurrentUser | null>({
  key: 'currentUserState',
  default: null,
});
